import { render, staticRenderFns } from "./distributorPayPopup.vue?vue&type=template&id=3fa8dcde&"
import script from "./distributorPayPopup.vue?vue&type=script&lang=js&"
export * from "./distributorPayPopup.vue?vue&type=script&lang=js&"
import style0 from "./distributorPayPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports